export default "__VITE_ASSET__2idZIDYy__"